import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; //useNavigate
import swal from "sweetalert";
import Modal from "./childComponents/popups/Modal";
import Loading from "./childComponents/appComponents/Loading";
import SelectField from "./childComponents/inputComponents/SelectField";

import { MdContentPasteSearch } from "react-icons/md";

let allRecordimage, tagName;

const Users = () => {
  const BUTTON_NAME = "Search"; // Submit Button Name
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [displayMessages, setDisplayMessages] = useState("");
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [searchType, setSearchType] = useState("");
  const [allRecords, setAllRecords] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      startDate: null,
      endDate: null,
    },
    select: {
      location: null,
      department: null,
      name: null,
      status: null,
    },
  });

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchDates: null,
    searchScript: null,
  });

  const [options, setOptions] = useState({
    inStatus: [],
    outStatus: [],
    location: [],
    department: [],
    name: [],
    status: [],
    tableSize: [
      { values: "10", item: "10" },
      { values: "20", item: "20" },
      { values: "50", item: "50" },
      { values: "100", item: "100" },
    ],
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  function extractColumn(arr, column) {
    return arr.map((x) => x[column]);
  }

  useEffect(() => {
    (async () => await fetchStaffData())();
    //(async () => await populateSelectMenu())();
  }, [dialogueState.editpost]);

  const searchDatabase = (event) => {
    event.preventDefault();
    const selectedType = event.currentTarget.dataset.value;

    setSearchType(selectedType); // still useful for UI display
    fetchStaffData(selectedType); // pass value directly
  };

  // Fetch the first day of the current month
  function getFirstDay() {
    const firstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
    );
    return firstDay.toISOString().split("T")[0];
  }

  // Fetch the Current Date
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  // Get specific date
  function getGivenDate(dates) {
    const today = new Date(dates);
    return today.toISOString().split("T")[0];
  }

  //Query constructor
  const queryConstructorString = (type = searchType) => {
    let query = "?type[eq]=staff&";
    let messages = "";

    // Helper function to handle query string updates
    const addToQuery = (condition, queryKey, value, label) => {
      if (condition) {
        query += `${queryKey}[eq]=${value}&`;
        messages += `${label.toUpperCase()}: ${value} | `;
      }
    };

    const { input, select } = formData;
    // Add query parameters dynamically

    addToQuery(select.location, "location", select.location, "Location");

    addToQuery(
      select.department,
      "department",
      select.department,
      "Department",
    );

    addToQuery(select.name, "name", select.name, "Employee");

    addToQuery(select.status, "status", select.status, "Status");

    if (query === "?type[eq]=staff") {
      query = `?date[eq]=${getCurrentDate()}&type[eq]=staff&`;
      messages = "ALL STAFF DATA";
    } else {
      query += "name[ne]=" + null;
    }

    return { query, messages };
  };

  // Fetch All Registry Records
  const fetchStaffData = async (
    page = 1,
    customSearchType = searchType,
    customPerPage = perPage,
  ) => {
    const { query, messages, initializeSearchDate } =
      queryConstructorString(customSearchType);

    // Display Current Search Request Parameters as a Message
    setDisplayMessages(messages);

    // Store a sample of Current Search Request Parameters for Dialogue Box
    setDialogueState((prev) => ({
      ...prev,
      searchScript: query,
    }));

    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(
          `${BASE_URL}inputname/staffdata${query}&page=${page}&per_page=${customPerPage}`,
        ),
        axios.get(
          `${BASE_URL}inputdepartment?type[eq]=staff&page=${page}&per_page=${customPerPage}`,
        ),
        axios.get(`${BASE_URL}inputlocation`),
        axios.get(`${BASE_URL}inputname`),
        axios.get(
          `${BASE_URL}inputcomponents?type[eq]=activeStatus&page=${page}&per_page=${customPerPage}`,
        ),
      ]);

      const [RegisterData, departmentData, locationData, nameData, statusData] =
        responses;

      const records = RegisterData?.data?.allData || [];

      if (records.length === 0) {
        swal(
          "Oops!",
          "Sorry! we did not find any information in the Post",
          "warning",
        );
        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      } else {
        setDialogueState((prev) => ({
          ...prev,
          searchDates: initializeSearchDate,
        }));

        setAllRecords(records);
        setFilteredRecords(records);
        setPagination(
          RegisterData.data.pagination || {
            current_page: 1,
            last_page: 1,
            per_page: 10,
            total: 0,
          },
        );

        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      }

      // populate the select menu

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName) => {
        if (columeObject?.data?.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(columeObject.data.allData, columeName),
          }));
        } else if (columeObject?.data?.status === 500) {
          swal("Oops!", columeObject.data.message, "error");
        }
      };

      populateSelect("department", departmentData, "departmentName");
      populateSelect("location", locationData, "location");
      populateSelect("name", nameData, "name");
      populateSelect("status", statusData, "productCategory");
    } catch (error) {
      swal("Error", "Error fetching Registry Data", "error");
      console.error("Error fetching Registry Data:", error);
    }
  };

  // Pagination
  // Pagination
  const getPaginationRange = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;

    const delta = 1; // how many pages around current

    const range = [];
    const rangeStart = Math.max(2, current - delta);
    const rangeEnd = Math.min(total - 1, current + delta);

    range.push(1);

    if (rangeStart > 2) {
      range.push("...");
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i);
    }

    if (rangeEnd < total - 1) {
      range.push("...");
    }

    if (total > 1) {
      range.push(total);
    }

    return range;
  };

  const changePage = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      fetchStaffData(page);
    }
  };

  const pages = getPaginationRange();

  // Search
  async function searchData(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
    fetchStaffData();
  }

  const handleFilter = (event) => {
    const text = event.target.value.toLowerCase();

    const newData = filteredRecords.filter(
      (row) =>
        (row.name ?? "").toLowerCase().includes(text) ||
        (row.fileNumber ?? "").toLowerCase().includes(text) ||
        (row.email ?? "").toLowerCase().includes(text) ||
        (row.department ?? "").toLowerCase().includes(text) ||
        (row.phone ?? "").toLowerCase().includes(text),
    );

    setAllRecords(newData.length > 0 ? newData : allRecords);
  };

  //Clean the Form
  const formCleanner = () => {
    fetchStaffData();

    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchDates: null,
      searchScript: null,
    }));
  };

  async function updateData(event, posts) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalUpdateStaff",
      modalTitle: "EDIT STAFF DATA",
      trigger: true,
      editpost: posts,
    }));
  }
  async function printIDcard(event, posts) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalStaffIDCard",
      modalTitle: "STAFF ID CARD",
      trigger: true,
      editpost: posts,
    }));
  }

  async function printIDcards() {
    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalBulkStaffIDCard",
      modalTitle: "BULK STAFF ID CARD",
      trigger: true,
      editpost: allRecords,
    }));
  }

  async function printUsers() {
    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalUsersSheet",
      modalTitle: "STAFF DETAILS",
      trigger: true,
      editpost: allRecords,
    }));
  }

  async function addData() {
    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const initializeEditposts = {
      firstName: "",
      lastName: "",
      sex: "",
      title: "",
      email: "",
      phone: "",
      userId: "",
      password: "",
      location: "",
      authority: "",
      status: "",
      shift: "",
      department: "",
      passport: "",
      bank: "",
      accountNo: "",
      salary: "",
    };

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPostStaff",
      modalTitle: "CREATE STAFF ACCOUNT",
      trigger: true,
      editpost: initializeEditposts,
    }));
  }

  async function DeletePost(event, id) {
    event.preventDefault();

    if (Number(localStorage.getItem("admin_authority")) < 2) {
      swal(
        "Noop!",
        "You need to be the admin to carry out this action",
        "warning",
      );
      return;
    }

    const deleteItem = async () => {
      axios.get("sanctum/csrf-cookie").then((response) => {
        axios.delete(`${BASE_URL}inputname/${id}`).then((res) => {
          if (res?.data?.status === 200) {
            swal("Deleted", res.data.message, "success");

            formCleanner();
          } else {
            swal("Oops!", res.data.message, "warning");
          }
        });
      });
    };

    await swal({
      title: "Are you sureee!!?",
      text: "Once deleted, you will not be able to recover this data againoo!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        (async () => await deleteItem())();
      } else {
        swal("Saved", "The data is safe!", "success");
      }
    });
  }

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        //searchDate={dialogueState.searchDates}
        formCleanner={formCleanner}
        searchScript={dialogueState.searchScript}
      />

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <i className="fa fa-search"></i> SEARCH STAFF DATA
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <SelectField
                    label="Location"
                    name="location"
                    size="2"
                    placeholder="Please Select An Office Location"
                    required=""
                    value={formData.select.location}
                    options={options.location}
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-location-arrow"
                  />

                  <SelectField
                    label="Department"
                    name="department"
                    size="2"
                    placeholder="Please Select A Department"
                    required=""
                    value={formData.select.department}
                    options={options.department}
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-table"
                  />

                  <SelectField
                    label="Name"
                    name="name"
                    size="2"
                    placeholder="Please Select An Employee Name"
                    required=""
                    value={formData.select.name}
                    options={options.name}
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-user"
                  />

                  <SelectField
                    label="Status"
                    name="status"
                    size="2"
                    placeholder="Please Select A Status"
                    required=""
                    value={formData.select.status}
                    options={options.status}
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-location-arrow"
                  />

                  <SelectField
                    label="Table Size"
                    name="tableSize"
                    size="2"
                    placeholder="Select a Table Size"
                    required="required"
                    value={perPage}
                    options={options.tableSize}
                    switchOptions={1}
                    type="text"
                    onChange={(type, key, value) => {
                      setPerPage(value);
                      fetchStaffData(1, searchType, value);
                    }}
                    icon="fa fa-columns"
                  />

                  <div className="col-lg-2">
                    <div className="row form-group mt-3">
                      <div className="col-lg-12">
                        <button
                          className="btn btn-success col-12 mt-4"
                          onClick={searchData}
                        >
                          <div className=" d-flex justify-content-center">
                            <i className="fa fa-search pt-1 pe-2"></i>
                            {reloadState.btnLoading}
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-9">
                    <div className="row form-group mt-3">
                      <div className="col-lg-3">
                        <button
                          className="btn btn-danger col-12 mt-4"
                          onClick={addData}
                          data-toggle="modal"
                          data-target="#exampleModal"
                        >
                          <div className=" d-flex justify-content-center">
                            <i className="fa fa-plus-square-o pt-1 pe-2"></i>
                            Add Staff
                          </div>
                        </button>
                      </div>

                      <div className="col-lg-3">
                        <button
                          className="btn btn-primary col-12 mt-4"
                          onClick={printUsers}
                          data-toggle="modal"
                          data-target="#exampleModal"
                          disabled
                        >
                          <div className="d-flex justify-content-center">
                            <i className="fa fa-print pt-1 pe-2"></i>
                            Print Document
                          </div>
                        </button>
                      </div>

                      <div className="col-lg-3">
                        <button
                          className="btn btn-primary col-12 mt-4"
                          onClick={printIDcards}
                          data-toggle="modal"
                          data-target="#exampleModal"
                        >
                          <div className=" d-flex justify-content-center">
                            <i className="fa fa-vcard-o pt-1 pe-2"></i>
                            Bulk ID Card
                          </div>
                        </button>
                      </div>
                      <div className="col-lg-3">
                        <div className="col-lg-12">
                          <Link
                            className="btn btn-success col-12 mt-4"
                            onClick={softreload}
                            to="/admin/users"
                          >
                            <i className="fa fa-refresh"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-success p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> ALL STAFF
                <span className="float-end me-3">{displayMessages}</span>
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div>
                    <div style={{ display: "flex", float: "right" }}>
                      <input
                        type="text"
                        name="searchData"
                        placeholder="..Name, Email, FileNo., Depatment, Phone No."
                        style={{ padding: "5px 7px" }}
                        onChange={handleFilter}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100%", overflowX: "scroll" }}>
                    <div style={{ width: "120%" }}>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            {[
                              { action: "Action", width: "17%" },
                              { action: "Employee", width: "11%" },
                              { action: "Image", width: "4%" },
                              { action: "Acct. Detail", width: "9%" },
                              { action: "Salary", width: "5%" },
                              { action: "Gender", width: "4%" },
                              { action: "OTP", width: "9%" },
                              { action: "Location/ Depart.", width: "14%" },
                              { action: "Access Level", width: "9%" },
                              { action: "Contact", width: "9%" },
                              { action: "Date", width: "9%" },
                            ].map((column, index) => (
                              <th scope="col" style={{ width: column.width }}>
                                {column.action}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {allRecords.map((allRecord, index) => {
                            if (
                              allRecord.passport === null ||
                              allRecord.passport === "null"
                            ) {
                              allRecordimage =
                                "upload/admin_passports/emptyImage.jpg";
                            } else {
                              allRecordimage = allRecord.passport;
                            }

                            switch (allRecord.authority) {
                              case 0:
                                tagName = "STAFF";
                                break;
                              case 1:
                                tagName = "DESK OFF.";
                                break;
                              case 2:
                                tagName = "WEB ADMIN";
                                break;
                              case 3:
                                tagName = "ADMIN";
                                break;
                              case 4:
                                tagName = "FULL ADMIN";
                                break;

                              default:
                                tagName = "Guest Staff";
                            }

                            return (
                              <tr key={index}>
                                <th scope="row">
                                  <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={(event) =>
                                      printIDcard(event, allRecord)
                                    }
                                  >
                                    <i className="fa fa-vcard-o"> </i>
                                    ID Card
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-warning me-3"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={(event) =>
                                      updateData(event, allRecord)
                                    }
                                  >
                                    <i className="fa fa-edit me-1"> </i>
                                    Edit
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={(event) =>
                                      DeletePost(event, allRecord.id)
                                    }
                                  >
                                    <i className="fa fa-trash me-1"> </i>
                                    Delete
                                  </button>
                                </th>

                                <td>
                                  {allRecord.name}
                                  <br />
                                  <em style={{ color: "red" }}>
                                    Staff No.: {allRecord.fileNumber}
                                  </em>
                                </td>
                                <td>
                                  <Link
                                    to={BACKEND_URL + allRecordimage}
                                    target="_blank"
                                  >
                                    <img
                                      src={BACKEND_URL + allRecordimage}
                                      alt=""
                                      width={60}
                                      height={70}
                                    />
                                  </Link>
                                </td>
                                <td>
                                  {allRecord.bank}
                                  <br />
                                  <em style={{ color: "red" }}>
                                    Acct No.: {allRecord.accountNo}
                                  </em>
                                </td>

                                <td>{allRecord.salary}</td>
                                <td>{allRecord.sex}</td>
                                <td>{allRecord.otp}</td>
                                <td>
                                  {allRecord.location}
                                  <br />
                                  <em style={{ color: "red" }}>
                                    Depart.: {allRecord.department}
                                  </em>
                                </td>
                                <td>
                                  {tagName}
                                  <br />
                                  <em style={{ color: "red" }}>
                                    Status.: {allRecord.status}
                                  </em>
                                </td>

                                <td>
                                  {allRecord.email}
                                  <br />
                                  <em style={{ color: "red" }}>
                                    Phone.: {allRecord.phone}
                                  </em>
                                </td>
                                <td>{getGivenDate(allRecord.created_at)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <nav>
                    <ul className="pagination">
                      {/* Prev */}
                      <li
                        className={`page-item ${pagination.current_page === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page - 1)
                          }
                        >
                          Prev
                        </button>
                      </li>

                      {/* Pages */}
                      {pages.map((page, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            page === pagination.current_page ? "active" : ""
                          } ${page === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => page !== "..." && changePage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      <li
                        className={`page-item ${pagination.current_page === pagination.last_page ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            changePage(pagination.current_page + 1)
                          }
                        >
                          Next
                        </button>
                      </li>

                      <li className="page-item ps-3 pe-3 pt-1 bg-primary text-white">
                        Total: {pagination.total}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  function softreload() {
    window.location.reload();
  }
};

export default Users;
